import * as React from 'react'
import { Icons, Typography } from '@lacedltd/laced-components'
import { useTranslation } from 'hooks'
import { withTranslations } from 'helpers'

import * as S from './NoProducts.styles'

const NoProducts = () => {
  const { t } = useTranslation()

  return (
    <S.Container>
      <S.CopyContainer>
        <Icons.Search />
        <Typography.Heading as="h3">
          {t('react_components.product.no_results')}
        </Typography.Heading>
        <Typography.Text variant="body">
          {t('react_components.product.no_products')}
        </Typography.Text>
      </S.CopyContainer>
    </S.Container>
  )
}

export default withTranslations(NoProducts)
